import DateRangeHtml from '../core/templates/date-range.html';

export function MechanicCtrl (
  $q,
  $rootScope,
  $scope,
  $state,
  $translate,
  $uibModal,
  $window,
  API,
  confirm,
  mechanic,
  mechanicsApi,
  messages,
  messengerApi,
  schedule,
  Schedule,
  sessionObjAPI,
  settings,
  workshopAPI
) {
  $scope.currency  = sessionObjAPI.currency();
  $scope.loaded    = true;
  $scope.session   = sessionObjAPI.base();
  $scope.settings  = settings;
  $scope.duplicate = false;
  $scope.mechanic  = mechanic || {
    cost_per_hour: 0.00,
    first_name   : null,
    id           : null,
    last_name    : null,
    mobile       : null,
    note         : null
  };

  $scope.originalMechanicCode = $scope.mechanic.mechanic_code;

  $scope.Schedule = new Schedule(schedule[mechanic.id]);

  $scope.delete = function() {
    mechanicsApi.check($scope.mechanic)
    .then(result => {
      return result
        ? workshopAPI.get('/mechanic/make_inactive', $scope.mechanic.id)
          .then(() => $translate.instant('JS_SPACE.MESSAGES.EMPLOYEE_ATTACHED_BOOKINGS_CANNOT_DELETE', {
            title: $rootScope.Company.labels.employeeTitle
          }))
        : confirm.generic($translate.instant('JS_SPACE.CONFIRM.DELETE_EMPLOYEE', {
          title: $rootScope.Company.labels.employeeTitle
        }))
        .then(() => workshopAPI.delete('/mechanic', $scope.mechanic.id))
        .then(() => $translate.instant('JS_SPACE.MESSAGES.DELETED.EMPLOYEE', {
          title: $rootScope.Company.labels.employeeTitle
        }));
    })
    .then(message => {
      messages.show(message, 'success');

      $state.go('app.mechanics');
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.deleteSchedule = function (weekday) {
    $scope.Schedule.delete(weekday)
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.DELETED.SCHEDULE'), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.save = function (form) {
    const method = $scope.mechanic.id ? 'patch' : 'post';
    const url    = $scope.mechanic.id ? '/mechanic' : '/mechanics';

    $scope.saving = true;

    mechanicsApi.checkMechanicCode($scope.originalMechanicCode, $scope.mechanic.mechanic_code)
    .then(result => {
      if (!result) {
        $scope.duplicate = true;
      }

      if ($scope.form.mechanic_code.duplicate || $scope.duplicate) {
        $scope.saving = false;

        return messages.show($translate.instant('EMPLOYEE_SPACE.CODE_ALREADY_USED', {
          title: $rootScope.Company.labels.employeeTitle
        }), 'error');
      }
      else {
        return workshopAPI[method](url, $scope.mechanic, 'mechanic')
        .then(mechanic => {
            $scope.mechanic = mechanic;

            return $scope.Schedule.saveDefault($scope.mechanic.id).then(() => mechanic);
          })
          .then(mechanic => {
            form.$setPristine();

            $state.go('app.mechanic', {
              id: mechanic.id
            },{
              reload: true
            });

            return $scope.settings.set_booking_schedule_hours && $scope.session.gold_or_higher && method === 'post'
            ? confirm.notify({ message: 'Don\'t forget to update your scheduled booking hours on the Public Bookings settings page to accommodate the addition of this mechanic' })
            : $q.when();
          })
          .then (() => {
            messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.EMPLOYEE', {
              title: $rootScope.Company.labels.employeeTitle
            }), 'success');
          })
          .catch(err => {
            messages.error(err);
          })
          .finally(() => {
            $scope.saving = false;
          });
      }
    });
  };

  $scope.checkMechanicCode = function () {
    return mechanicsApi.checkMechanicCode($scope.originalMechanicCode, $scope.mechanic.mechanic_code)
    .then(result => $scope.form.mechanic_code.duplicate = !result)
    .catch(err => {
      messages.error(err);

      return $q.reject();
    });
  };

  $scope.selectTime = function(event, index, property, unavailableTimesIndex) {
    const picker = $(event.currentTarget).datetimepicker({
      initialDate : new Date(),
      showMeridian: true,
      startView   : 'day'
    }).on('changeDate', ev => {
      let date = new Date(ev.date.valueOf());

      date = new Date(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes()
      ).toISOString();

      if (unavailableTimesIndex >= 0) {
        $scope.Schedule.weekDefault[index].unavailable_times[unavailableTimesIndex][property] = date;
      }
      else {
        $scope.Schedule.weekDefault[index][property] = date;
      }

      if (!$scope.$$phase) {
        $scope.$apply();
      }

      $(picker).datetimepicker('hide');
    });

    $('.datetimepicker').addClass('hide-date');

    $(picker).datetimepicker('show');
  };

  $scope.sendSMS = function () {
    messengerApi.sms({
      name   : (`${ $scope.mechanic.first_name } ${ $scope.mechanic.last_name }`),
      send_to: $scope.mechanic.mobile
    }).then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.MESSAGE_SENT'), 'success');
    });
  };

  $scope.printTimecard = function () {
    $uibModal.open({
      templateUrl: DateRangeHtml,
      controller : ['$scope', '$uibModalInstance', 'dateParsing', function ($scope, $uibModalInstance, dateParsing) {
        $scope.dates = {
          begin: dateParsing.today(),
          end  : ''
        };

        $scope.cancel = function () {
          $uibModalInstance.dismiss();
        };

        $scope.choose = function () {
          $uibModalInstance.close($scope.dates);
        };
      }]
    }).result
    .then(dates => {
      $window.open(`${API.url}/reports/mechanic_time_card/pdf/${$scope.mechanic.id}/${dates.begin}/${dates.end}`);
    });
  };
};